export default __webpack_public_path__ + "static/45488-97b67bf7890c58897a8942cfc728c966.jpg";